import { ImageGalleryItem, ImageGalleryRoot } from "./image-gallery";

export const ImageGallery = {
  Root: ImageGalleryRoot,
  Item: ImageGalleryItem,
};
